import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./quiz-list.scss";
import Header from "../../../components/Header";
import ScrollToTop from "../../../components/ScrollTop";
import FooterTwo from "../../../components/Footer/FooterTwo";
import { formatDate } from "../formatted-date";

const QuizList = () => {
  const [quizDates, setQuizDates] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/quizzes/index.json")
      .then((res) => res.json())
      .then((data) => setQuizDates(data))
      .catch((err) => console.error("Failed to load quiz index:", err));
  }, []);

  const handleQuizClick = (dateStr) => {
    navigate(`/current-affairs-quiz/${dateStr}`);
  };

  const sortedDates = [...quizDates].sort().reverse();

  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        topbarEnable="enable"
      />
      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <div className="quiz-list-wrapper">
            <h2 className="quiz-list-title">
              Jnani Junction – Daily Current Affairs Quiz
            </h2>
            <div className="quiz-list">
              {sortedDates.map((date) => (
                <div
                  key={date}
                  className="quiz-list-item"
                  onClick={() => handleQuizClick(date)}
                >
                  <div className="quiz-card-header">
                    <h3>📅 {formatDate(date)}</h3>
                  </div>

                  <div className="quiz-card-body">
                    <p>📝 10 Questions</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <ScrollToTop />
        </div>
      </div>
      <FooterTwo />
    </>
  );
};

export default QuizList;
